import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'delete-company-modal',
  templateUrl: './delete-company-modal.component.html',
  styleUrls: ['./delete-company-modal.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DeleteCompanyModalComponent {
  @Input() public isOpen: boolean = false;
  @Input() public company: { id?: number; businessName?: string };
  @Input() public isDeleting: boolean = false;
  @Input() public headerKey: string = 'DELETE_COMPANY_PROFILE';
  @Input() public descriptionKey: string = 'DELETE_COMPANY_DESCRIPTION';
  @Input() public confirmButtonKey: string = 'BUTTON.DELETE_COMPANY';
  @Input() public fallbackNameKey: string = 'LABELS.COMPANY';
  @Output() public confirmed: EventEmitter<void> = new EventEmitter<void>();
  @Output() public cancelled: EventEmitter<void> = new EventEmitter<void>();

  constructor(private translateService: TranslateService) {}

  public get displayName(): string {
    return this.company?.businessName || `${this.translateService.instant(this.fallbackNameKey)} ${this.company?.id}`;
  }

  public onCancel(): void {
    if (this.isDeleting) {
      return;
    }
    this.cancelled.emit();
  }

  public onConfirm(): void {
    if (this.isDeleting) {
      return;
    }
    this.confirmed.emit();
  }
}
